import { extendBfldrCacheTime } from '../../../../wpl/image/src/image';

import { ImageProps } from './image-props';

export const AssigneeAlvin24Image = (props: ImageProps) => {
	const src = extendBfldrCacheTime(
		'https://dam-cdn.atl.orangelogic.com/AssetLink/w3ew83t6fv2xk12878a62ut0qlbr50w8.svg',
	);
	return (
		// eslint-disable-next-line no-restricted-syntax
		<img
			height={24}
			width={24}
			alt={props.alt}
			src={src}
			data-testid={props['data-testid']}
			className={props.className}
		/>
	);
};
